import * as actionTypes from '../../actions/lp/actionTypes';
import { LpReducerProps } from '../../actions/lp/types';
import { pageRoutes } from '../../routes';
import { getAuthorizedServiceProvidersState } from '../../utils/entityPicker';
import { mapPermissionsToTerms } from '../../utils/mapPermissionsToTerms';
import { Action } from '../types';

export const initialState: LpReducerProps = {
  authorizedEntities: {},
  authorizedLps: null,
  authorizedDSPs: null,
  lpSelected: null,
  lpPickerInput: '',
};

export function lpReducer(state = initialState, action: Action<string, any>) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_AUTHORIZED_LPS_SUCCESS: {
      const { serviceProvidersList, serviceProviderIdentifierType } = payload;
      return {
        ...state,
        [getAuthorizedServiceProvidersState(serviceProviderIdentifierType)]:
          serviceProvidersList,
      };
    }
    case actionTypes.GET_AUTHORIZED_LPS_FAILURE:
      return {
        ...state,
        authorizedLps: [],
      };
    case actionTypes.GET_AUTHORIZED_ENTITIES_SUCCESS:
      return {
        ...state,
        authorizedEntities: mapPermissionsToTerms(
          payload.permissionToEntitiesMap
        ),
      };
    case actionTypes.GET_AUTHORIZED_LP_SELECTED_SUCCESS:
      return {
        ...state,
        lpSelected: payload,
      };
    case actionTypes.GET_AUTHORIZED_LP_SELECTED_FAILURE: {
      window.location.pathname = pageRoutes.PICKER_PAGE; // If user is unAuthorized for any reason, he should be navigated to /global-picker page for AuthZ
      return state;
    }
    case actionTypes.SET_LP_PICKER_INPUT: {
      return {
        ...state,
        lpPickerInput: action.payload,
      };
    }
    default:
      return state;
  }
}
